import GraphQLRequest from "Utilities/GraphQLClient/GraphQLClient";

export const getUserAudiences = async (customerUrl, webUserGuid = null) => {
  let variables = {
    webUserGuid,
  };

  const query = `query GetUserAudiences($webUserGuid: String) {
    userAudiencesV2(webUserGuid: $webUserGuid) {
      audiences
      googleAudiences
    }
  }`;

  try {
    const response = await GraphQLRequest(customerUrl, query, variables);
    return response.userAudiencesV2;
  } catch (e) {
    console.error(e)
    return {
      audiences: [],
      googleAudiences: []
    }; 
  }
  
  
};
